































































































































































































































































































































































































































































































import constants from '@/utils/constants';
import moment from 'moment';
import { Component, Vue, Watch } from 'vue-property-decorator';
@Component({
  filters: {
    formatDate(val: any) {
      let date: any = val;
      if (moment(date).isValid()) {
        date = moment(date).format('DD/MM/YYYY');
      }
      return date;
    },
    formatTime(val: any) {
      let time: any = val;
      if (moment(time).isValid()) {
        time = moment(time).format('HH:MM:SS');
      }
      return time;
    }
  }
})
export default class OrderListDetail extends Vue {
  $swal: any;
  public constants: any = constants;
  public fieldsSet = [
    { key: 'pdf', label: 'PDF', class: 'text-center text-nowrap' }
  ];
  public statusOptions = [
    {
      text: 'Please select an option',
      value: null
    },
    {
      text: 'TRANSFERRED',
      value: 'TRANSFERRED'
    },
    {
      text: 'PREPARED',
      value: 'PREPARED'
    },
    {
      text: 'ON_DELIVERY',
      value: 'ON_DELIVERY'
    },
    {
      text: 'COMPLETED',
      value: 'COMPLETED'
    }
  ];
  orderStatusState = null;

  mounted() {
    this.getOrderDetailsApi();
  }

  @Watch('orderStatusState')
  watchOrderStatusValue() {
    if (
      this.orderStatusState &&
      this.orderStatusState !== this.orderDetails.Status.OrderStatus
    ) {
      this.$store.dispatch('UpdateOrderStatus', {
        orderId: this.$router.currentRoute.params.id,
        order_status: this.orderStatusState
      });
    }
  }

  @Watch('updateOrderStatus.isSuccess')
  watchOrderStatusSuccess() {
    if (this.updateOrderStatus.isSuccess) {
      this.orderDetails.Status.OrderStatus = this.orderStatusState;
    }
  }

  @Watch('updateOrderStatus.error')
  watchOrderStatusError() {
    if (this.updateOrderStatus.error) {
      this.$swal(
        constants.SOMETHING_WROING,
        this.updateOrderStatus.error,
        constants.STATUS_ERROR
      );
    }
  }

  @Watch('cancelOrderStatus.isSuccess')
  watchCancleOrderStatus() {
    if (this.cancelOrderStatus.isSuccess) {
      this.getOrderDetailsApi();
    }
  }

  get orderDetails() {
    return this.$store.getters.GetOrderReportDetail;
  }

  get updateOrderStatus() {
    return this.$store.getters.GetUpdateOrderStatus;
  }

  get cancelOrderStatus() {
    return this.$store.getters.CancelOrderStatus;
  }

  // to get order detail
  getOrderDetailsApi() {
    let params = {
      id: this.$router.currentRoute.params.id,
      type:
        this.$router.currentRoute.params.type === 'gofood'
          ? 'online'
          : this.$router.currentRoute.params.type
    };
    return this.$store.dispatch('GetOneOrderReportDetail', params);
  }

  checkPointAcquired(pointString) {
    if (
      pointString !== '' &&
      pointString !== '0 Qraved Points' &&
      pointString !== 'N/A'
    ) {
      return true;
    }
    return false;
  }

  cancelStatus() {
    const payload = {
      orderId: this.$router.currentRoute.params.id
    };
    return this.$store.dispatch('CancelOrder', payload);
  }
}
